import React from 'react';

export const PrintKOT = React.forwardRef((props, ref) => {
    return (
        <div className={`mx-auto text-sm p-2 ${props.isPrint ? '' : 'hidden'}`} ref={ref}>
            {
                props.isPrint && <div className="space-y-1 bg-white px-1 py-2">
                    <div className="my-2 h-[1px] bg-black" />
                    <div className="mt-2">
                        <h2 className="text-center text-2xl font-bold uppercase">#{props.payload.data.ordid}</h2>
                    </div>
                    <div className="my-2 h-[1px] bg-black" />
                    <div className='flex items-center justify-between'>
                        <p className="text-lg font-medium">Item Description</p>
                        <p className="text-lg font-medium">QTY</p>
                    </div>
                    <div className="my-2 h-[1px] bg-black" />
                    {
                        props.payload.data.items.map((item, index) => (
                            <div className='flex items-center justify-between' key={index}>
                                <p className="text-lg">{item.name}</p>
                                <p className="text-lg">{item.qty}</p>
                            </div>
                        ))
                    }
                    <div className="my-2 h-[1px] bg-black" />
                    <p className="text-sm">Provider: <span className='font-medium'>{props.payload.provider}</span></p>
                    <p className="text-sm">Unitname: <span className='font-medium'>{props.payload.unit}</span></p>
                    <p className="text-center text-sm mt-1">
                        {new Date().toISOString()}
                    </p>
                </div>
            }
        </div>
    )
});
